var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3782_71817)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3782_71817",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3782_71817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_3782_71817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C17.3672 12 12 17.3672 12 24C12 30.6328 17.3672 36 24 36C30.6328 36 36 30.6328 36 24C36 17.3672 30.6328 12 24 12ZM29.0625 31.2L24 28.1437L18.9375 31.2L20.2922 25.4391L15.7969 21.5578L21.6891 21.0328L24 15.5766L26.3109 21.0328L32.2031 21.5578L27.7078 25.4437L29.0625 31.2Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3782_71817",
    x1: 12.7781,
    y1: 9.24074,
    x2: 39.2241,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3782_71817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferred);
export default __webpack_public_path__ + "static/media/Preferred.354103c0eb98e14b09dced83642ce0c2.svg";
export { ForwardRef as ReactComponent };